import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/shared/ui/select"
import { Editor } from "@tiptap/react"
type Level = 1 | 2 | 3 | 4 | 5 | 6;

const HeadingSelect = ({ editor }: { editor: Editor | null }) => {
    const value = editor?.isActive("heading", { level: 1 })
        ? "h1"
        : editor?.isActive("heading", { level: 2 })
            ? "h2"
            : editor?.isActive("heading", { level: 3 })
                ? "h3"
                : "p"

    return (
        <Select
            value={value}
            onValueChange={(val) => {
                if (val === "p") {
                    editor.chain().focus().setParagraph().run()
                } else {
                    const level = parseInt(val.replace("h", ""), 10) as Level;
                    // Sempre aplica o heading ao texto selecionado ou parágrafo atual
                    editor.chain().focus().setHeading({ level }).run()
                }
            }}
        >
            <SelectTrigger
                className="w-[110px] h-8 px-2 text-xs font-medium bg-dark text-zinc-200 border-1 border-zinc-700 focus:ring-0 focus:ring-offset-0 hover:bg-zinc-700 rounded-md"
            >
                <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-zinc-900 text-zinc-200 border-zinc-700">
                <SelectItem value="p">Parágrafo</SelectItem>
                <SelectItem value="h1">Título H1</SelectItem>
                <SelectItem value="h2">Título H2</SelectItem>
                <SelectItem value="h3">Título H3</SelectItem>
            </SelectContent>
        </Select>
    )
}

export default HeadingSelect